import type { ReactNode } from 'react'
import React, { useEffect } from 'react'
import { useAccount } from '../context/AccountContext'
import { useAuthentication } from '../context/AuthenticationContext'
import sentryService from '../services/SentryService'

interface SentryContextProviderProps {
  children: ReactNode
}

const SentryContextProvider: React.FC<SentryContextProviderProps> = ({ children }) => {
  const { account } = useAccount()
  const { scope } = useAuthentication()

  useEffect(() => {
    sentryService.setUserContext(account, scope)
  }, [account, scope])

  return <>{children}</>
}

export default SentryContextProvider
